/**
 * Scrolls the columns-panel list so the given column's row (shown or hidden
 * section) is centered in view.
 */
export function scrollToPanelRow(container: HTMLElement, columnKey: string): void {
  const escaped = CSS.escape(columnKey);
  const row = container.querySelector<HTMLElement>(
    `[data-testid="columns-panel-shown-${escaped}"], [data-testid="columns-panel-hidden-${escaped}"]`
  );
  row?.scrollIntoView({behavior: 'smooth', block: 'center'});
}
